export default "__VITE_ASSET__PBQq6R1b__"